import React from 'react';
import Layout from '../components/Layout';
import ContactSection from '../components/ContactSection';
import '../styles/impressum-page.css';
import '../styles/page-layout.css';

const ImpressumPage: React.FC = () => {
  return (
    <Layout
      title="Impressum | Stimm.DEV - Rechtliche Hinweise"
      description="Impressum von Stimm.DEV - Kontaktinformationen und rechtliche Hinweise gemäß TMG"
      keywords="Impressum, Kontakt, Rechtlich, TMG, Stimm.DEV, Berlin, Henri Stimm"
    >
      <section className="wrapper">
        <div className="page-container">
          {/* Header */}
          <div className="page-header">
            <span className="section-title">Rechtliche Hinweise</span>
            <h1>Impressum</h1>
            <p>
              Angaben gemäß § 5 TMG (Telemediengesetz)
            </p>
          </div>

          {/* Impressum Content */}
          <div className="page-content-card">
            
            <h2 style={{ color: '#009ed1', marginTop: '0', marginBottom: '2rem', fontSize: '1.8rem' }}>
              Anbieter & Kontakt
            </h2>
            
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: '2rem', 
              marginBottom: '3rem',
              background: 'rgba(0, 158, 209, 0.1)',
              padding: '2rem',
              borderRadius: '0.75rem',
              border: '1px solid rgba(0, 158, 209, 0.2)'
            }}>
              <div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Inhaber
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  <strong style={{ color: '#ffffff' }}>Henri Stimm</strong><br />
                  Software-Entwickler & Gründer<br />
                  Kirchstraße 21<br />
                  10557 Berlin
                </p>
              </div>
              <div>
                <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                  Kontaktdaten
                </h4>
                <p style={{ lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                  E-Mail: <a href="mailto:service@stimm.dev" style={{ color: '#009ed1', textDecoration: 'none' }}>service@stimm.dev</a><br />
                  Telefon: <a href="tel:+493042141523" style={{ color: '#009ed1', textDecoration: 'none' }}>+49 30 42141523</a><br />
                  Website: <span style={{ color: 'rgba(255, 255, 255, 0.9)' }}>www.stimm.dev</span>
                </p>
              </div>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Steuerliche Angaben
            </h2>
            
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              border: '1px solid rgba(0, 158, 209, 0.2)',
              marginBottom: '3rem'
            }}>
              <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                Umsatzsteuer-Identifikationsnummer
              </h4>
              <p style={{ fontSize: '1.2rem', fontWeight: '600', color: '#ffffff', margin: '0 0 0.5rem 0' }}>
                DE 49 302 658 077
              </p>
              <p style={{ fontSize: '0.9rem', opacity: '0.8', color: 'rgba(255, 255, 255, 0.8)', margin: '0 0 2rem 0' }}>
                gemäß §27a Umsatzsteuergesetz
              </p>
              
              <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                Berufsrechtliche Regelungen
              </h4>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', lineHeight: '1.6', margin: '0' }}>
                <strong style={{ color: '#ffffff' }}>Berufsbezeichnung:</strong> Software-Entwickler<br />
                <strong style={{ color: '#ffffff' }}>Zuständige Kammer:</strong> IHK Berlin<br />
                <strong style={{ color: '#ffffff' }}>Verliehen in:</strong> Deutschland
              </p>
            </div>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Haftungsausschluss
            </h2>
            
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Haftung für Inhalte
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1.5rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p style={{ lineHeight: '1.7', marginBottom: '2rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
            
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.3rem', margin: '0 0 1rem 0', padding: '0' }}>
              Haftung für Links
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '3rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Urheberrecht
            </h2>
            
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              marginBottom: '1.5rem',
              border: '1px solid rgba(0, 158, 209, 0.2)'
            }}>
              <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                Wichtiger Hinweis
              </h4>
              <p style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', margin: '0' }}>
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              </p>
            </div>
            <p style={{ lineHeight: '1.7', marginBottom: '3rem', color: 'rgba(255, 255, 255, 0.9)' }}>
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>

            <h2 style={{ color: '#009ed1', marginBottom: '1.5rem', fontSize: '1.8rem' }}>
              Streitschlichtung
            </h2>
            
            <div style={{ 
              background: 'rgba(0, 158, 209, 0.1)', 
              padding: '2rem', 
              borderRadius: '0.75rem',
              marginBottom: '1.5rem',
              border: '1px solid rgba(0, 158, 209, 0.2)'
            }}>
              <h4 style={{ color: '#009ed1', marginBottom: '1rem', fontSize: '1.1rem' }}>
                EU-Streitschlichtung
              </h4>
              <p style={{ lineHeight: '1.7', color: 'rgba(255, 255, 255, 0.9)', marginBottom: '1rem' }}>
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
              </p>
              <a 
                href="https://ec.europa.eu/consumers/odr" 
                target="_blank" 
                rel="noopener"
                style={{ 
                  color: '#009ed1', 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  fontWeight: '500'
                }}
              >
                ec.europa.eu/consumers/odr
              </a>
            </div>
            <p style={{ lineHeight: '1.7', fontSize: '0.9rem', opacity: '0.8', color: 'rgba(255, 255, 255, 0.8)', margin: '0' }}>
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>

          {/* Quick Contact Info */}
          <div style={{
            maxWidth: '600px',
            margin: '3rem auto 4rem auto',
            textAlign: 'center',
            padding: '2rem',
            background: 'linear-gradient(135deg, rgba(0, 158, 209, 0.1), rgba(0, 158, 209, 0.05))',
            borderRadius: '1rem',
            border: '1px solid rgba(0, 158, 209, 0.2)',
            backdropFilter: 'blur(10px)'
          }}>
            <h3 style={{ color: '#009ed1', marginBottom: '1rem', margin: '0 0 1rem 0', padding: '0' }}>
              Haben Sie Fragen?
            </h3>
            <p style={{ marginBottom: '1.5rem', lineHeight: '1.6', color: 'rgba(255, 255, 255, 0.9)' }}>
              Kontaktieren Sie uns gerne bei rechtlichen Fragen oder Anliegen zu diesem Impressum.
            </p>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '2rem', 
              flexWrap: 'wrap',
              fontSize: '0.9rem'
            }}>
              <a 
                href="mailto:service@stimm.dev" 
                style={{ 
                  color: '#009ed1', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                service@stimm.dev
              </a>
              <a 
                href="tel:+493042141523" 
                style={{ 
                  color: '#009ed1', 
                  textDecoration: 'none',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  transition: 'color 0.3s ease'
                }}
              >
                +49 30 42141523
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <ContactSection />
    </Layout>
  );
};

export default ImpressumPage;
